import axiosClient from '../axiosClient';

export const getDashboardStats = () =>
  axiosClient.get('/admin/dashboard');
